import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";

const PROMOS = [
  {
    id: "halloween-special",
    badge: "Halloween Special",
    text: (
      <>
        <span className="font-bold">BOOK BY OCT 31</span> — Halloween yard
        transformations now available
      </>
    ),
  },
  {
    id: "mulch-bonus",
    badge: "Bonus Offer",
    text: (
      <>
        <span className="font-bold">FREE</span> edge & trim with every mulch service
      </>
    ),
  },
];

const STORAGE_KEY = "ironclad-promo-dismissed-v3";

export default function PromoBanner({ onDismiss }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PROMOS.length), 5500);
    return () => clearInterval(t);
  }, []);

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {}
    onDismiss?.();
  };

  const current = PROMOS[idx];

  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-primary text-primary-foreground border-b border-black/20 overflow-hidden"
    >
      <div className="container-ic flex items-center gap-3 py-2.5 md:py-2 relative">
        {/* Left badge — desktop only */}
        <div className="hidden md:flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] font-bold opacity-80 shrink-0">
          <Sparkles className="h-3 w-3" />
          {current.badge}
        </div>

        {/* Sliding messages */}
        <div className="flex-1 overflow-hidden relative h-5 md:h-5">
          {PROMOS.map((p, i) => (
            <div
              key={p.id}
              className={`absolute inset-0 flex items-center justify-center md:justify-start transition-all duration-500 ${
                i === idx
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 -translate-y-3 pointer-events-none"
              }`}
              data-testid={`promo-msg-${p.id}`}
            >
              <span className="text-xs md:text-sm uppercase tracking-wider text-center md:text-left">
                {p.text}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#halloween"
          className="hidden sm:inline-flex shrink-0 items-center gap-1 text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold border border-black/40 hover:bg-black hover:text-primary px-3 py-1 transition-colors"
          data-testid="promo-cta"
        >
          See Special
        </a>

        {/* Dismiss */}
        <button
          type="button"
          onClick={handleDismiss}
          className="shrink-0 w-7 h-7 flex items-center justify-center hover:bg-black/15 transition-colors"
          aria-label="Dismiss promo"
          data-testid="promo-dismiss"
        >
          <X className="h-4 w-4" />
        </button>

        {/* Dot indicators */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex gap-1">
          {PROMOS.map((_, i) => (
            <span
              key={i}
              className={`h-0.5 transition-all ${
                i === idx ? "w-6 bg-black/60" : "w-2 bg-black/20"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
